import { render, staticRenderFns } from "./firstpurchase.vue?vue&type=template&id=e0523536&scoped=true"
import script from "./firstpurchase.vue?vue&type=script&lang=ts"
export * from "./firstpurchase.vue?vue&type=script&lang=ts"
import style0 from "./firstpurchase.vue?vue&type=style&index=0&id=e0523536&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0523536",
  null
  
)

export default component.exports